export default "__VITE_ASSET__0ae69541__"